import React from 'react';
import reactDom from 'react-dom';
import { App } from './App';
import './styles/app.scss'

reactDom.render(
    <App />,
  document.getElementById('root')
);

